export const camelToWords = (str: string) => {
  return str.split('_').join(' ')
}
